import { CSSProperties } from 'react';
import styled from 'styled-components';

import Cost from '@r1-frontend/ui-react/components/costs/Cost';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import DescribedCost from './DescribedCost';

const StyledDescribedCost = styled(DescribedCost)<{ isReverse?: boolean, align?: CSSProperties['alignItems'] }>`
    flex-direction: ${({ isReverse }) => isReverse ? 'column-reverse' : 'column'};
    align-items: ${({ align = 'flex-start' }) => align};
    cursor: ${({ onClick }) => onClick ? 'pointer' : 'initial'};

    ${Cost} + ${Paragraph4} {
        margin-left: 8px;
    }
`;

export const Installment = styled.div`
    display: flex;
    color: ${COLORS.TextInfo};
    flex-wrap: nowrap;

    i {
        margin-left: 4px;
        line-height: 0;
        align-self: center;

        & > ${Svg} {
            width: 12px;
            height: 12px;
        }
    }

    span {
        @media (max-width: ${wideBreakpoints.mobile}) {
            display: none;
        }
    }
`;

export default StyledDescribedCost;
